<template>
  <div class="d-flex flex-wrap pa-2">
    <div
      v-for="postType in this.postTypes"
      :key="postType.name"
      class="card__container"
    >
      <BaseCard
        class="card-wrapper primary--text"
        :ripple="true"
        :outlined="$vuetify.breakpoint.smAndUp"
        @click="$store.dispatch('share/setPostType', postType.name)"
      >
        <div class="card-wrapper__content">
          <div class="text-center">
            <BaseIcon color="primary" :size="48">{{ postType.icon }}</BaseIcon>
            <div v-text="postType.displayName" class="text--primary mt-4"></div>
          </div>
        </div>
      </BaseCard>
    </div>
  </div>
</template>

<script>
import getPostTypes from "../variables/PostTypes";
export default {
  name: "TheShareModalPostTypeSelection",
  computed: {
    postTypes() {
      return getPostTypes();
    }
  }
};
</script>

<style lang="scss" scoped>
.card__container {
  flex-basis: 50%;
  padding: 8px;
}
.card-wrapper {
  position: relative;
  padding-top: 125%;
  width: 100%;
}
.card-wrapper__content {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
